// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { IConsultarDare, Types } from './types';

export interface IRequestDareGuia {
	dare: string;
	orgao: number;
}

export interface IRequestDareCpf {
	cpf: string;
	orgao: number;
}

export interface IRequestTaxasDare {
	taxasCorreio: boolean;
	numeroRg: string;
	nome: string;
}

export interface IRequestGerarDare {
	cpf: string;
	enderecoContribuinte: string;
	postoCodigo: number;
	postoDescricao: string;
	ipUsuario: string;
	emailTo: string;
	taxasReq: IRequestTaxasDare[];
}

export function consultarDareGuiaRequest(
	token: string,
	payload: IRequestDareGuia,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_DARE_GUIA_REQUEST,
		token,
		payload,
	};
}

export function consultarDareCpfRequest(
	token: string,
	payload: IRequestDareCpf,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_DARE_CPF_REQUEST,
		token,
		payload,
	};
}

export function consultarDareSuccess(
	status: number,
	data: IConsultarDare[] | null,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_DARE_SUCCESS,
		payload: {
			status,
			data,
		},
	};
}

export function consultarDareClear(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_DARE_CLEAR,
		payload: null,
	};
}
